import { useEffect } from 'react';

/**
 * Updates the browser tab title — `<page> | AUTO-REMAP` — and
 * restores the previous title on unmount so deep links / hot reloads
 * don't leave a stale label.
 *
 * Usage:
 *   useDocumentTitle('Dashboard');                    // Dashboard | AUTO-REMAP
 *   useDocumentTitle('Tickets', { count: unread });  // Tickets (3) | AUTO-REMAP
 *
 * Keep the labels short, in English, Title Case — the title bar is
 * cramped enough as it is and most browsers truncate ~30 chars.
 */
export default function useDocumentTitle(label, { count } = {}) {
  useEffect(() => {
    if (!label) return undefined;
    const prev = document.title;
    const badge = Number.isFinite(count) && count > 0 ? ` (${count})` : '';
    document.title = `${label}${badge} | AUTO-REMAP`;
    return () => { document.title = prev; };
  }, [label, count]);
}

// Centralized label map so we never end up with two pages using slightly
// different capitalisation / wording for the same route key.
export const PAGE_TITLES = {
  // Admin
  dashboard:        'Dashboard',
  orders:           'Orders',
  customers:        'Customers',
  transactions:     'Transactions',
  'recharge-reviews': 'Recharges on review',
  tickets:          'Tickets',
  catalog:          'Price catalog',
  tools:            'Tools',
  maintenance:      'Maintenance',
  duplicates:       'Duplicates',
  ips:              'IP management',
  analytics:        'Analytics',
  settings:         'Settings',
  notifications:    'Notifications',
  // Customer
  'new-order':      'New order',
  recharge:         'Wallet',
  profile:          'My profile',
  'order-details':  'Order details',
  files:            'My files',
};
